import { readFileAsText } from '@/features/csvImport/admin/utils/readFileAsText';

/**
 * The lines of a CSV that carry anything, header first.
 *
 * Deliberately a split rather than a parse: this backs the row count on the file card and the
 * checks that run before the file is sent anywhere, neither of which is the authority on what
 * the file holds — the server is. A quoted field containing a newline is therefore seen as
 * several lines, which is acceptable while the templates are one record per line.
 */
export const readCsvLines = async (file: File): Promise<string[]> => {
  const text = await readFileAsText(file);

  return text.split(/\r\n|\r|\n/).filter((line) => line.trim() !== '');
};
